import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useProjectReviewStyles = makeStyles({
  page: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowY: "auto",
    backgroundColor: projectIqTokens.bg,
    fontFamily: projectIqTokens.fontFamily,
    padding: designTokens.spacing[8],
  },
  pageContent: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[6],
    width: "100%",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
  },
  sectionHeading: {
    fontSize: "16px",
    fontWeight: "700",
    color: projectIqTokens.ink,
    margin: "0",
    fontFamily: projectIqTokens.fontFamily,
  },
});
